import { RegionCode } from "brandRegionConfig";
import { AvailableRegionsContext } from "core/context/AvailableRegionsContext";
import { useContext } from "react";

export function useAvailableRegions(): RegionCode[] {
  return useContext(AvailableRegionsContext);
}
